export enum GalleryViewStoreEvent {
  /**
   * Browsing images
   */
  browse = 'browse',

  /**
   * Browsing next element
   */
  next = 'next',

  /**
   * Browsing previous element
   */
  previous = 'previous',

  /**
   * Gallery clicked
   */
  click = 'click',

  /**
   * navigation is started
   */
  start = 'start',
}
